module.exports = __webpack_public_path__ + "static/media/RESUME_CLAYTON_SACHS.0695ac2e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RESUME_CLAYTON_SACHS.pdf
// module id = 314
// module chunks = 0